export default "__VITE_ASSET__Bh1HMSRa__"